module.exports = __webpack_public_path__ + "static/media/gq.dea38d5a.svg";